export enum CustomFieldsRoutes {
  root = 'custom-fields',
}
